
	import Vue from "vue";
	import helpers from "../inc/helpers";

	export default Vue.extend({
		name: "Levy",

		props: ["data", "assessedValue"],

		computed: {
			taxYear(): string {
				return this.data.TaxYear;
			},

			levyType(): string {
				return this.data.IssueExtent;
			},

			ballotMillage(): string {
				return helpers.round(this.data.LevyMillage, 2).toFixed(2);
			},

			description(): string {
				return this.data.LevyDesc;
			},

			years(): string {
				return this.data.LevyYrs;
			},

			type(): string {
				return this.data.LevyType;
			},

			effMillage(): string {
				return helpers.round(this.data.NewM, 2).toFixed(2);
			},

			currentCost(): number {
				let value = 0;

				if (!!this.data.CurrentAmt) {
					value = helpers.round(this.data.CurrentAmt * this.assessedValue, 2);
				} else if (this.data.CurrentM) {
					if (this.data.NonQualify == 1) {
						value = helpers.round(this.data.CurrentM * (1.0 * 0.001) * this.assessedValue, 2);
					} else {
						value = helpers.round(this.data.CurrentM * (0.875 * 0.001) * this.assessedValue, 2);
					}
				}

				return Math.ceil(value);
			},

			newCost(): number {
				let value = 0;

				if (!!this.data.NewAmt) {
					value = helpers.round(this.data.NewAmt * this.assessedValue, 2);
				} else if (this.data.NewM) {
					if (this.data.NonQualify == 1) {
						value = helpers.round(this.data.NewM * (1.0 * 0.001) * this.assessedValue, 2);
					} else {
						value = helpers.round(this.data.NewM * (0.875 * 0.001) * this.assessedValue, 2);
					}
				}

				return Math.ceil(value);
			},

			change(): number {
				return this.newCost - this.currentCost;
			},
		},

		filters: {
			formatCurrency(val: string): string {
				return helpers.formatCurrency(val);
			},
		},
	});
